import React, { useEffect, useMemo, useState } from "react"
import { useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import {
  Button,
  Card,
  CardBody,
  Select,
  SelectItem,
} from "@heroui/react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
//import "react-date-range/dist/styles.css" // main css file
//import "react-date-range/dist/theme/default.css" // theme css file
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers"
import dayjs from "dayjs"
import { toast } from "react-toastify"
import { COLUMN_ALIGN_TYPE, COLUMN_TYPE, FOOTER_TYPE } from "../../components/NextUITable.jsx"
import { setAccount, setFilter } from "../../state/ledgerSlice.jsx"
import { calculateTotal } from "../../Utility/utility.js"
import {
  ErrorCard,
  LoadingCard,
  MainContainer,
  NextUITable,
} from "../../components/index.js"
import { useFetchWithBody, useGet, usePost } from "../../api/reactQueryCustomHooks.jsx"
import { apiRoute, linksUrl } from "../../constants/enum.js"

const Ledger = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { compCode, startDate, endDate, isMultipleCompany } = useSelector((state) => state.company)
  const { filter } = useSelector((state) => state.ledger)
  const [searchAccount, setSearchAccount] = useState(filter && filter.actypeid ? filter.actypeid : "")
  const [filterDate, setFilterDate] = useState({
    start: filter && filter.fromdate ? filter.fromdate : startDate ? startDate : null,
    end: filter && filter.todate ? filter.todate : endDate ? endDate : null
  })

  const { isLoading, isError: isErrorFetch, data: accountType = [] } = useFetchWithBody({
    url: apiRoute.ledger.accountType,
    queryKey: "LedgerAccountType",
  })

  const {
    isPending,
    isError,
    data = [],// ledger = [],
    mutate: filterLedger,
  } = usePost({
    url: apiRoute.ledger.fetch,
    queryKey: "Ledger",
  })

  const totalOpBal = useMemo(
    () =>
      calculateTotal({
        data: data,
        columnName: "OpBal",
      }),
    [data]
  )

  const totalDebit = useMemo(
    () =>
      calculateTotal({
        data: data,
        columnName: "Debit",
      }),
    [data]
  )

  const totalCredit = useMemo(
    () =>
      calculateTotal({
        data: data,
        columnName: "Credit",
      }),
    [data]
  )

  const totalBalance = useMemo(
    () =>
      calculateTotal({
        data: data,
        columnName: "Balance",
      }),
    [data]
  )

  let downloadDataFooter = {
    AC_ID: "",
    Ac_Desc: "",
    OpBal: "Total: " + totalOpBal,
    OpBal_Type: "",
    Debit: "Total: " + totalDebit,
    Credit: "Total: " + totalCredit,
    Balance: "Total: " + totalBalance,
    Bal_Type: "",
  }

  const exportColumns = [
    {
      uid: "AC_ID",
      name: "Account Id",
    },
    {
      uid: "Ac_Desc",
      name: "Account Description",
    },
    {
      uid: "OpBal",
      name: "Opening Balance",
    },
    {
      uid: "OpBal_Type",
      name: "",
    },
    {
      uid: "Debit",
      name: "Total Debit Transaction",
    },
    {
      uid: "Credit",
      name: "Total Credit Transaction",
    },
    {
      uid: "Balance",
      name: "Closing Balance",
    },
    {
      uid: "Bal_Type",
      name: "",
    },
  ]

  const funLoadData = () => {
    if (searchAccount) {
      filterLedger({
        data: {
          compcode: compCode.join(","),
          dy: 1,
          ac_id: "",
          actypeid: searchAccount,
          fromdate: filterDate.start ? new Date(filterDate.start).toISOString().split("T")[0] : null,
          todate: filterDate.end ? new Date(filterDate.end).toISOString().split("T")[0] : null,
        },
      })
    }
  }

  useEffect(() => {
    if (isMultipleCompany)
      navigate(linksUrl.multiCompLedger.get)
    else
      funLoadData()
  }, [])

  const handleFilter = () => {
    if (searchAccount) {
      funLoadData()
      dispatch(setFilter({
        fromdate: new Date(filterDate.start),
        todate: new Date(filterDate.end),
        actypeid: searchAccount,
        actypename: "",
      }))
    } else {
      toast.error("Please select Account Type !", {
        position: "top-center",
      })
    }
  }

  const INITIAL_VISIBLE_COLUMNS = [
    "AC_ID",
    "Ac_Desc",
    "OpBal",
    "OpBal_Type",
    "Debit",
    "Credit",
    "Balance",
    "Bal_Type",
  ]

  const columns = [
    {
      name: "Account Id",
      uid: "AC_ID",
      sortable: true,

    },
    {
      name: "Account Description",
      uid: "Ac_Desc",

      type: COLUMN_TYPE.link,
      sortable: true,
      onClick: (row) => {
        navigate(linksUrl.ledger.getAccount)
        let acTypeName = accountType.filter((ele) => ele.actypeid == searchAccount)

        dispatch(
          setFilter({
            fromdate: new Date(filterDate.start),
            todate: new Date(filterDate.end),
            actypeid: searchAccount,
            actypename: acTypeName.length > 0 ? acTypeName[0]?.actypename : "",
          })
        )
        dispatch(
          setAccount({
            acId: row.AC_ID,
            acDesc: row.Ac_Desc,
            compCode: 0
          })
        )
      },
    },
    {
      name: "Opening Balance",
      uid: "OpBal",
      sortable: true,
      align: COLUMN_ALIGN_TYPE.right,
      footer: {
        type: FOOTER_TYPE.text,
        label: "Total: ",
        value: totalOpBal,
      },
    },
    {
      name: "",
      uid: "OpBal_Type",
      sortable: true,
    },
    {
      name: "Total Debit Transaction",
      uid: "Debit",
      align: COLUMN_ALIGN_TYPE.right,
      sortable: true,
      footer: {
        type: FOOTER_TYPE.text,
        label: "Total: ",
        value: totalDebit

      },
    },
    {
      uid: "Credit",
      name: "Total Credit Transaction",
      align: COLUMN_ALIGN_TYPE.right,
      sortable: true,
      footer: {
        type: FOOTER_TYPE.text,
        label: "Total: ",
        value: totalCredit,

      },
    },
    {
      uid: "Balance",
      name: "Closing Balance",
      align: COLUMN_ALIGN_TYPE.right,
      sortable: true,

      footer: {
        type: FOOTER_TYPE.text,
        label: "Total: ",
        value: totalBalance,

      },
    },
    {
      uid: "Bal_Type",
      name: "",
      sortable: true,
    },
  ]

  if (isPending) {
    return <LoadingCard />
  }

  if (isError || isErrorFetch) {
    return <ErrorCard />
  }

  return (
    <div>
      <MainContainer pageName="Ledger" info={[]} breadcrumbs={["Ledger"]}>
        {/* filter */}
        <Card shadow="sm" radius="sm" className="mb-3 h-full">
          <CardBody className="p-2">
            <div className="flex flex-wrap items-center gap-2">
              {/* date */}
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label={"Start Date"}
                  views={["day", "month", "year"]}
                  format="DD/MM/YYYY"
                  value={filterDate.start
                    ? dayjs(filterDate.start)
                    : filterDate.start}
                  onChange={(newValue) => {
                    setFilterDate((prev) => {
                      return { ...prev, start: dayjs(newValue).format("YYYY-MM-DD") }
                    })
                  }}
                  sx={{ width: "145px" }}
                  slotProps={{ textField: { size: "small" } }}
                />
                <DatePicker
                  label={"End Date"}
                  views={["day", "month", "year"]}
                  format="DD/MM/YYYY"
                  value={filterDate.end
                    ? dayjs(filterDate.end)
                    : filterDate.end}
                  onChange={(newValue) => {
                    setFilterDate((prev) => {

                      return { ...prev, end: dayjs(newValue).format("YYYY-MM-DD") }
                    })
                  }}
                  slotProps={{ textField: { size: "small" } }}
                  sx={{ width: "145px" }}
                />
              </LocalizationProvider>
              {/*  end of date */}
              <Select
                isRequired
                size="sm"
                items={accountType ? accountType : []}
                label="Account Type"
                placeholder="Select an Account"
                className="max-w-52"
                selectionMode="single"
                isVirtualized
                variant="bordered"
                onChange={(e) => setSearchAccount(e.target.value)}
                selectedKeys={[searchAccount]}
              >
                {(account) => {
                  return (
                    <SelectItem
                      key={account.actypeid}
                    >
                      {account.actypename}
                    </SelectItem>
                  )
                }}
              </Select>
              <Button
                size="sm"
                color="primary"
                startContent={<FontAwesomeIcon icon={faMagnifyingGlass} />}
                onPress={handleFilter}
              //isLoading={isPending}
              >
                Search
              </Button>
            </div>
          </CardBody>
        </Card>

        {/* end of filter */}
        <NextUITable
          INITIAL_VISIBLE_COLUMNS={INITIAL_VISIBLE_COLUMNS}
          data={data}
          //handleDataChange={handleDataChange}
          columns={columns}
          exportColumns={exportColumns}
          downloadDataFooter={downloadDataFooter}
          downloadFileName="Ledger"
          showAdvanceFilter={false}
          id="AC_ID"
        />
      </MainContainer>
    </div>
  )
}

export default Ledger
